import reduceReducers from 'reduce-reducers';

//Siblings reducers
import projectIdentificationReducer from './project-identification-reducer';

export default reduceReducers(projectIdentificationReducer);
